import Storage from './lstorage'

export default {
  writeFile (ctx, data) {
    return ctx.$http.post(Storage.get('serverDir') + '/user/writefile', data)
  },
  authenticate (ctx, data) {
    return ctx.$http.post(Storage.get('serverDir') + '/user/authenticate', data)
  },
  signin (ctx, data) {
    if (data._id) {
      return ctx.$http.put(Storage.get('serverDir') + '/user/signin', data)
    } else {
      return ctx.$http.post(Storage.get('serverDir') + '/user/signin', data)
    }
  },
  deleteImage (ctx, data) {
    return ctx.$http.put(Storage.get('serverDir') + '/chat/upload', data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  user: null,
  userShow: {},
  setUserShow (some) {
    this.userShow = some
  },
  getUser () {
    // window.alert(JSON.stringify(Storage.get('user')))
    let data = Storage.get('user')
    // this.normalizeObject(data)
    return data
  },
  normalizeString (str) {
    const cadenaSinAcentos = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    return cadenaSinAcentos
  },
  normalizeObject (obj) {
    for (const key in obj) {
      if (typeof obj[key] === 'string') {
        obj[key] = this.normalizeString(obj[key])
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        // Llamada recursiva para subobjetos
        this.normalizeObject(obj[key])
      }
    }
    return obj
  },
  getUserNormalize () {
    // window.alert(JSON.stringify(Storage.get('user')))
    let data = Storage.get('user')
    this.normalizeObject(data)
    // window.alert(JSON.stringify(data))
    return data
  },
  setUser (newUser) {
    this.user = Storage.setNormalize('user', newUser)
  },
  getAll (ctx, data) {
    console.log('user::getAll', JSON.stringify(data))
    return ctx.$http.post(Storage.get('serverDir') + '/user/getAll', data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  getNum (ctx, data) {
    console.log('user::getNum', JSON.stringify(data))
    return ctx.$http.post(Storage.get('serverDir') + '/user/getNum', data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  get (ctx, data) {
    console.log('user::get', JSON.stringify(data))
    return ctx.$http.get(Storage.get('serverDir') + '/user/' + data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  testUser (ctx, data) {
    console.log('user::testUser', JSON.stringify(data))
    return ctx.$http.post(Storage.get('serverDir') + '/user/test', data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  logout (ctx) {
    const user = this.getUser()
    if (user) {
      return ctx.$http.put(Storage.get('serverDir') + '/user/updatelogout', user).then(r => {
        if (r.status === 200) {
          Storage.clearLocal(true)
          this.user = null
          return r.text()
        } else {
          return r.text().then(d => {
            Storage.clearLocal(true)
            this.user = null
            throw d
          })
        }
      })
    } else {
      Storage.clearLocal(true)
      this.user = null
    }
  },
  updateELO (ctx, data) {
    return ctx.$http.put(Storage.get('serverDir') + '/user/updateelo', data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  updateUser (ctx, data) {
    return ctx.$http.put(Storage.get('serverDir') + '/user/updateuser', data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  writeFILE (ctx, data) {
    return ctx.$http.put(Storage.get('serverDir') + '/user/writefile', data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },
  /* updateClub (ctx, data) {
    return ctx.$http.put(Storage.get('serverDir') + '/user/updateclub', data).then(r => {
      if (r.status === 200) {
        return r.text()
      } else {
        return r.text().then(d => {
          throw d
        })
      }
    })
  },*/
  init () {
    this.user = Storage.get('user')
  },
  user_acces (perm = 'authenticate') {
    if (this.getUser() && perm !== 'authenticate') {
      return this.user.rol === perm
    }
    if (perm === 'authenticate') {
      if (this.getUser()) {
        return true
      }
    }
    if (perm === 'guest') {
      return true
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/services/user.js